module.exports = __webpack_public_path__ + "img/0-117.32836f69.jpg";